import React from 'react';
import { Column } from 'new/elements/Table/types';
import { SourceName } from 'new/elements/SourceName';
import { ChipBadge } from 'new/elements/ChipBadge';
import { Nexset } from 'new/entities/Nexset';

export const columns = [
  {
    name: 'Details',
    field: 'details',
    renderRow: (row) => {
      const { isDetected, source, parentDataSet } = row;
      let description = parentDataSet?.name || '';
      let descriptionLabel = 'From nexset ';
      if (isDetected) {
        description = source?.name || '';
        descriptionLabel = 'Detected from ';
      }
      return (
        <SourceName
          type={row.isDetected ? 'source' : 'nexset'}
          icon={row.sourceIcon}
          name={row.name}
          description={descriptionLabel + description}
        />
      );
    },
    width: 35,
  },
  {
    name: 'Transformed Nexsets',
    sortable: true,
    field: 'transformedCount',
  },
  {
    name: 'Destination',
    sortable: true,
    field: 'destinationCount',
    center: true,
  },
  {
    name: 'Shares',
    sortable: true,
    field: 'sharesCount',
    center: true,
  },
  {
    name: 'Identification',
    field: 'id',
    renderRow: (row) => <ChipBadge color="success" label={row.id + ''} />,
    center: true,
  },
] as Column<Nexset>[];
